import { Box, Paper, Skeleton, Grid } from '@mui/material';

export default function DashboardSkeleton() {
  return (
    <Box>
      {/* Today's Overview Skeleton */}
      <Paper sx={{ p: 3, mb: 3, borderRadius: 2 }}>
        <Skeleton variant="text" width={200} height={32} sx={{ mb: 1 }} />
        <Skeleton variant="text" width={300} height={24} sx={{ mb: 3 }} />
        <Grid container spacing={3}>
          {[1, 2, 3, 4].map((i) => (
            <Grid item xs={12} sm={6} md={3} key={i}>
              <Paper sx={{ p: 2.5, display: 'flex', alignItems: 'center', gap: 2 }}>
                <Skeleton variant="rounded" width={56} height={56} />
                <Box sx={{ flexGrow: 1 }}>
                  <Skeleton variant="text" width={80} height={40} />
                  <Skeleton variant="text" width={100} height={20} />
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Paper>

      {/* Two Column Cards */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, height: 320, borderRadius: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="text" width={120} height={28} />
            </Box>
            <Box sx={{ display: 'flex', gap: 4, mb: 4 }}>
              {[1, 2, 3].map((i) => (
                <Box key={i}>
                  <Skeleton variant="text" width={60} height={40} />
                  <Skeleton variant="text" width={80} height={20} />
                </Box>
              ))}
            </Box>
            <Skeleton variant="text" width={100} height={20} sx={{ mb: 2 }} />
            <Box sx={{ display: 'flex', gap: 1, height: 80 }}>
              {[1, 2, 3, 4, 5, 6, 7].map((i) => (
                <Box
                  key={i}
                  sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}
                >
                  <Skeleton variant="text" width={20} height={20} />
                  <Skeleton variant="rounded" width="100%" height={40} />
                  <Skeleton variant="text" width={24} height={16} />
                </Box>
              ))}
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, height: 320, borderRadius: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="text" width={160} height={28} />
            </Box>
            <Box sx={{ display: 'flex', gap: 3, mb: 3 }}>
              {[1, 2].map((i) => (
                <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Skeleton variant="circular" width={20} height={20} />
                  <Box>
                    <Skeleton variant="text" width={40} height={32} />
                    <Skeleton variant="text" width={50} height={16} />
                  </Box>
                </Box>
              ))}
            </Box>
            <Skeleton variant="text" width={60} height={20} sx={{ mb: 1.5 }} />
            <Box sx={{ display: 'flex', gap: 1, mb: 3 }}>
              {[1, 2, 3].map((i) => (
                <Skeleton key={i} variant="rounded" width={100} height={24} />
              ))}
            </Box>
            <Skeleton variant="text" width={140} height={20} sx={{ mb: 1.5 }} />
            {[1, 2, 3].map((i) => (
              <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <Skeleton variant="circular" width={20} height={20} />
                <Skeleton variant="text" width={60} height={20} />
                <Skeleton variant="rounded" sx={{ flexGrow: 1 }} height={8} />
                <Skeleton variant="text" width={20} height={20} />
              </Box>
            ))}
          </Paper>
        </Grid>
      </Grid>

      {/* Second Row */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, height: 280, borderRadius: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="text" width={140} height={28} />
            </Box>
            <Skeleton variant="rounded" width="100%" height={80} sx={{ mb: 2 }} />
            {[1, 2].map((i) => (
              <Skeleton key={i} variant="rounded" width="100%" height={48} sx={{ mb: 1 }} />
            ))}
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, height: 280, borderRadius: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="text" width={120} height={28} />
            </Box>
            {[1, 2, 3].map((i) => (
              <Skeleton key={i} variant="rounded" width="100%" height={56} sx={{ mb: 1 }} />
            ))}
          </Paper>
        </Grid>
      </Grid>

      {/* Shop Performance */}
      <Box sx={{ mb: 2 }}>
        <Skeleton variant="text" width={160} height={28} sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          {[1, 2, 3, 4].map((i) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
              <Paper sx={{ p: 2.5, borderRadius: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Skeleton variant="circular" width={24} height={24} />
                    <Skeleton variant="text" width={80} height={24} />
                  </Box>
                  <Skeleton variant="rounded" width={56} height={24} />
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                  <Skeleton variant="circular" width={20} height={20} />
                  <Skeleton variant="text" width={100} height={20} />
                </Box>
                <Box sx={{ display: 'flex', gap: 3, mb: 2 }}>
                  {[1, 2].map((j) => (
                    <Box key={j}>
                      <Skeleton variant="text" width={40} height={32} />
                      <Skeleton variant="text" width={60} height={16} />
                    </Box>
                  ))}
                </Box>
                <Box sx={{ pt: 2, borderTop: '1px solid', borderColor: 'divider' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Skeleton variant="circular" width={20} height={20} />
                    <Skeleton variant="text" width={100} height={20} />
                  </Box>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
